// extracted by mini-css-extract-plugin
export default {"container":"VideoErrorScreen_container__6LXgq","iconContainer":"VideoErrorScreen_iconContainer__Vaqg4"};